export const inlineStyle = {
  modal: {
    marginTop: '0px !important',
    marginLeft: 'auto',
    marginRight: 'auto'
  }
}


// WEBPACK FOOTER //
// ./src/styles/custom.js